import { Colors } from "~/jsx/theme";
import {
  XBattleCard,
  XPlayerIcon,
  XResourceWithAmount,
} from "~/jsx/components/design";
import { useGame } from "~/app";

export const XBattleCardWithPodium = () => {
  const { game } = useGame();
  const { currentBattleCard } = game;
  return (
    <XBattleCard
      card={currentBattleCard}
      style={{
        boxShadow: "2px 2px 2px rgba(0, 0, 0, 0.33)",
      }}
      rightElements={[1, 2, 3].map((place) => (
        <XPodiumNode key={place} targetPlace={place} />
      ))}
    />
  );
};

const XPodiumNode = ({ targetPlace }: { targetPlace: number }) => {
  const { game } = useGame();
  const { combatPodium } = game;

  const players =
    combatPodium?.find(({ index }) => index === targetPlace)?.group ?? [];

  return (
    <>
      {players.map((player) => (
        <div
          key={player.id}
          style={{
            display: "flex",
            backgroundColor: Colors.grey.dark,
            alignItems: "center",
            position: "relative",
            left: "50%",
            borderRadius: 4,
            padding: 6,
            border: "solid 1px black",
          }}
        >
          <XPlayerIcon width={16} playerId={player.id} />
          <XResourceWithAmount
            amount={player.combatPoints}
            type="combatPoint"
            width={16}
          />
        </div>
      ))}
    </>
  );
};
